import React, { useState, useCallback } from 'react';
import DeviceFilterExtended from './components/DeviceFilterExtended';
import OutdoorFilter from './components/OutdoorFilter';
import AddDeviceForm from './components/AddDeviceForm'; // Import the new form

function App() {
  const [mode, setMode] = useState('indoor'); // 'indoor' lub 'outdoor'
  const [showAddForm, setShowAddForm] = useState(false);
  // This state will be used to trigger a refresh in DeviceFilterExtended
  const [refreshKey, setRefreshKey] = useState(0);

  const handleDeviceAdded = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1); // Increment key to trigger useEffect in child
    setShowAddForm(false); // Optionally hide form after adding
  }, []);

  return (
    <div className="App" style={{ padding: '20px' }}>
      <h1>Aplikacja Porównywarka Klimatyzacji</h1>

      <div style={{ marginBottom: '20px' }}>
        <strong>Tryb porównania:</strong>{' '}
        <label>
          <input
            type="radio"
            value="indoor"
            checked={mode === 'indoor'}
            onChange={() => setMode('indoor')}
          />
          Jednostki wewnętrzne
        </label>{' '}
        <label style={{ marginLeft: '20px' }}>
          <input
            type="radio"
            value="outdoor"
            checked={mode === 'outdoor'}
            onChange={() => setMode('outdoor')}
          />
          Jednostki zewnętrzne (agregaty)
        </label>
      </div>

      <button onClick={() => setShowAddForm(!showAddForm)} style={{ marginBottom: '20px' }}>
        {showAddForm ? 'Ukryj formularz dodawania' : 'Dodaj nowe urządzenie'}
      </button>

      {showAddForm && <AddDeviceForm onDeviceAdded={handleDeviceAdded} />}

      {mode === 'indoor' ? <DeviceFilterExtended refreshKey={refreshKey} /> : <OutdoorFilter refreshKey={refreshKey} />}
      {/* Assuming OutdoorFilter might also need a refreshKey if it lists devices */}
    </div>
  );
}

export default App;

